import React from 'react';
import * as s from './styled-tip-key-image-background';

const TipCard = ({icon, marginLeft, paddingTop, paddingLeft}) => {
  return (
    <s.Box marginLeft={marginLeft} paddingTop={paddingTop} paddingLeft={paddingLeft}>
      <img src={icon} alt="" />
    </s.Box>
  );
};

export default TipCard;
